<template>
  <el-dialog title="回复用户" :visible.sync="dialogVisible" width="700px" append-to-body :close-on-click-modal="false">
    <div class="reply-user-container">
      <el-form :model="form" ref="formRef" :rules="rules" label-width="100px">
        <el-form-item label="回复内容：" prop="reply_text">
          <el-input v-model="form.reply_text" type="textarea" :rows="5" placeholder="请输入回复内容" maxlength="200" show-word-limit />
        </el-form-item>

        <el-form-item label="留言图片：" >
          <el-upload
            v-model="form.reply_image"
            :action="apiUrl"
            drag
            multiple
            :limit="4"
            accept="image/bmp,image/png,image/jpg"
            list-type="picture-card"
            :file-list="getStableImageFileList('reply_image', form.reply_image)"
            :headers="file_headers"
            :on-preview="questionPreview"
            :on-success="questionSuccess"
            :on-remove="questionRemove"
            :on-change="questionChange"
            :on-error="questionError"
            :on-exceed="questionExceed"
            :before-upload="beforeUpload"
          >
          <!-- 非必填，最多上传 4 张，每张大小不超过 2M，支持jpg、png、bmp，支持删除重新上传，默认为空，可编辑 -->
            <i v-if="form.reply_image.length < 4" class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogImageVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
          <div class="upload-tooltip">
            最多上传4张，每张大小不超过2M，支持JPG、BMP、PNG格式
          </div>
        </el-form-item>
      </el-form>
    </div>


    <div slot="footer" class="dialog-footer">
      <el-button type="default" size="small" :loading="dialogloading" @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" size="small" :loading="dialogloading" @click="onSubmit">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import BASE_API from '@/config';
import { getToken } from '@/utils/localStorage.js';
import { wxMerchantComplaintReplayUserApi } from '@/api/merchant_complain_handle'
import { appendImageInSelectionOrder, imageUploadMixin, removeImageByUploadFile } from '@/utils/imageUpload.js';

class DefaultForm {
  constructor () {
    this.mch_id = '';
    this.complaint_id = '';
    this.reply_text = '';
    this.reply_image = [];
  }
}


export default {
  name: 'ReplyUsers',
  mixins: [imageUploadMixin],
  data() {
    return {
      file_headers: {
        //头带当前用户信息
        Authorization: 'Bearer ' + getToken(),
      },
      apiUrl: BASE_API + 'admin/work_upload_admin',
      dialogVisible: false,
      form: new DefaultForm(),
      rules: {
        reply_text: [
          { required: true, message: '请输入回复内容', trigger: 'blur' }
        ]
      },
      dialogImageUrl: '',
      dialogImageVisible: false,
      dialogloading: false
    };
  },
  methods: {
    triggleVisible (data) {
      this.resetImageUploadScope('reply_image')
      this.form = new DefaultForm()
      this.form.mch_id = data.mch_id
      this.form.complaint_id = data.complaint_id
      this.dialogVisible = true;
      this.$refs.formRef && this.$refs.formRef.resetFields()
    },

    beforeUpload (file) {
      const acceptFileTypes = ['image/bmp', 'image/png', 'image/jpg']
      if (!acceptFileTypes.includes(file.type)) {
        this.$message.error('图片格式错误，支持jpg、png、bmp');
        return false;
      }
      if (file.size > (1024 * 1024 * 2)) {
        this.$message.error('图片大小不能超过2M');
        return false;
      }
      return true
    },

    questionPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogImageVisible = true;
    },

    questionChange(file, fileList) {
      this.trackImageUpload('reply_image', file, fileList)
    },

    questionSuccess(response, file, fileList) {
      if (!this.isCurrentImageUpload('reply_image', file)) return
      if (response.code != 200) {
        file.status = 'fail'
        this.trackImageUpload('reply_image', file, fileList)
        this.$message.error(response.message);
      } else {
        this.form.reply_image = appendImageInSelectionOrder(this.form.reply_image, file, { url: response.data.path, name: response.data.name || file.name });
        this.trackImageUpload('reply_image', file, fileList)
        this.$message.success(response.message);
      }
    },

    questionRemove(file, fileList) {
      this.form.reply_image = removeImageByUploadFile(this.form.reply_image, file);
      this.removeTrackedImage('reply_image', file, fileList)
    },

    questionError(error, file, fileList) {
      if (!this.isCurrentImageUpload('reply_image', file)) return
      this.trackImageUpload('reply_image', file, fileList)
      this.$message.error(`${file.name || '图片'}上传失败`)
    },

    questionExceed(files, fileList) {
      this.handleImageUploadExceed(4, files, fileList)
    },

    onSubmit () {
      if (!this.guardImageUploads(['reply_image'])) return
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          const params = {
            ...this.form,
            reply_image: this.form.reply_image.map(it => it.url)
          }
          console.log('this.form', params)
          this.dialogloading = true
          wxMerchantComplaintReplayUserApi(params).then(res => {
            if (res.data.code == 200) {
              this.$emit('success')
              this.$message.success('操作成功');
              this.dialogVisible = false
              this.dialogloading = false
            } else {
              this.$message.error(res.message);
              this.dialogloading = false
            }
          }).catch(() => {
            this.dialogloading = false
          })
        }
      })
      
    }
  }
};

</script>
